import { render } from "./UploadPanel.vue?vue&type=template&id=0f009c1b&scoped=true"
import script from "./UploadPanel.vue?vue&type=script&lang=ts"
export * from "./UploadPanel.vue?vue&type=script&lang=ts"

import "./UploadPanel.vue?vue&type=style&index=0&id=0f009c1b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f009c1b"

export default script